import dayjs from "dayjs"
import { useState } from "react"
import { MAX_ASSIGNMENT_YEARS, localtext, type NewLineManagerAssignment } from "./AssignLineManagerDeputy.static"

type FormErrors = {
  currentLineManager: string | undefined
  endDate: string | undefined
  startingDate: string | undefined
  temporaryDeputy: string | undefined
  ticketUrl: string | undefined
}

export const useAssignLineManagerDeputy = (onAssignmentAdded: (assignment: NewLineManagerAssignment) => void) => {
  // TODO: wire backend employee identity lookup and persist stable employee IDs.
  const [currentLineManager, setCurrentLineManager] = useState("")
  const [endDate, setEndDate] = useState<string | undefined>(undefined)
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)
  const [startingDate, setStartingDate] = useState<string | undefined>(undefined)
  const [submitted, setSubmitted] = useState(false)
  const [temporaryDeputy, setTemporaryDeputy] = useState("")
  const [ticketUrl, setTicketUrl] = useState("")

  const maxDate = dayjs().add(MAX_ASSIGNMENT_YEARS, "year")
  const maxEndDate = maxDate.toISOString()

  const errors: FormErrors = {
    currentLineManager: !currentLineManager ? localtext.ErrorRequired : undefined,
    endDate: !endDate
      ? localtext.ErrorRequired
      : startingDate && !dayjs(endDate).isAfter(dayjs(startingDate))
        ? localtext.ErrorEndDateAfterStart
        : dayjs(endDate).isAfter(maxDate, "day")
          ? localtext.ErrorEndDateMaximum
        : undefined,
    startingDate: !startingDate
      ? localtext.ErrorRequired
      : dayjs(startingDate).isBefore(dayjs(), "day")
        ? localtext.ErrorStartingDateToday
        : undefined,
    temporaryDeputy: !temporaryDeputy ? localtext.ErrorRequired : undefined,
    ticketUrl: !ticketUrl.trim() ? localtext.ErrorRequired : undefined,
  }

  const emptyErrors: FormErrors = {
    currentLineManager: undefined,
    endDate: undefined,
    startingDate: undefined,
    temporaryDeputy: undefined,
    ticketUrl: undefined,
  }

  const isValid = Object.values(errors).every(e => e === undefined)
  const coverageDuration = startingDate && endDate && !errors.startingDate && !errors.endDate
    ? dayjs(endDate).startOf("day").diff(dayjs(startingDate).startOf("day"), "day") + 1
    : undefined

  const handleSubmit = () => {
    setSubmitted(true)
    if (!isValid) return

    setIsConfirmationOpen(true)
  }

  const confirmAssignment = () => {
    // TODO: wire backend validation and line_manager.assign mutation before clearing the form.
    onAssignmentAdded({
      currentLineManager,
      endDate: endDate as string,
      startingDate: startingDate as string,
      temporaryDeputy,
      ticketUrl: ticketUrl.trim(),
    })
    setCurrentLineManager("")
    setEndDate(undefined)
    setIsConfirmationOpen(false)
    setStartingDate(undefined)
    setSubmitted(false)
    setTemporaryDeputy("")
    setTicketUrl("")
  }

  return {
    closeConfirmation: () => setIsConfirmationOpen(false),
    confirmAssignment,
    coverageDuration,
    currentLineManager,
    endDate,
    errors: submitted ? errors : emptyErrors,
    handleSubmit,
    isConfirmationOpen,
    maxEndDate,
    setCurrentLineManager,
    setEndDate,
    setStartingDate,
    setTemporaryDeputy,
    setTicketUrl,
    startingDate,
    temporaryDeputy,
    ticketUrl,
  }
}
